import { AppTab } from "../../../global/ui/tabs";
import { BlogNavigationTabs } from "./BlogNavigationProvider";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";

export const BlogTabsContent = () => {
  const user = useSelector((state: RootState) => state.user.value);

  return (
    <>
      <AppTab label={"Explore"} value={BlogNavigationTabs.EXPLORE} />
      {user?.loggedUser && (
        <AppTab label={"Following"} value={BlogNavigationTabs.FOLLOWING} />
      )}
    </>
  );
};
